import Service from "../service";
const url = 'question'
const faq = {
    get() {
        return Service.get(url);
    },
}
export default faq